function transformItem2Dto(item) {
  console.log(item.validUntilDate);
  const dto = {
    customerID: item.id,
    ...item,
    dateIssued: item.dateIssued && new Date(item.dateIssued).toDateString(),
    validUntilDate: item.validUntilDate && new Date(item.validUntilDate).toDateString()
  };
  delete dto.id;
  return dto;
}

export const apiOverrides = { transformItem2Dto };
